<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)"> </eaglei-leaflet-layer-header>
